const defaultState = {
    error: null,
    row: null,
    liveState: null,
    isLoading: false
};

const normalizeMarketplaceContextData = (data) => {
    if (!data) {
        return { row: null, liveState: null };
    }

    // GET /marketplace-context returns { contexts: [{ row, liveState }, ...] }
    if (Array.isArray(data.contexts)) {
        const context = data.contexts[0] ?? null;
        return {
            row: context?.row ?? null,
            liveState: context?.liveState ?? null
        };
    }

    // Direct shape (e.g. test mocks, legacy responses)
    return {
        row: data.row ?? null,
        liveState: data.liveState ?? null
    };
};

const marketplaceContextReducer = (state = defaultState, { type, payload }) => {
    switch (type) {
        case "MARKETPLACE-CONTEXT:FETCH-PENDING":
            return { ...state, isLoading: true };

        case "MARKETPLACE-CONTEXT:FETCH-SUCCESS": {
            // handleApiAction wraps the response in payload.data
            const data = payload?.data || payload;
            const { row, liveState } = normalizeMarketplaceContextData(data);
            return {
                ...state,
                isLoading: false,
                row,
                liveState,
                error: null
            };
        }
        case "MARKETPLACE-CONTEXT:FETCH-ERROR":
            return { ...state, isLoading: false, error: payload };

        // SAVE (POST) lifecycle — response is { written: true } or { skipped: true }.
        // row/liveState are not in the POST response; the middleware chains a FETCH after
        // success to populate them.
        case "MARKETPLACE-CONTEXT:SAVE-PENDING":
            return { ...state, error: null };

        case "MARKETPLACE-CONTEXT:SAVE-SUCCESS":
            return { ...state, error: null };

        case "MARKETPLACE-CONTEXT:SAVE-ERROR":
            return { ...state, error: payload };

        case "MARKETPLACE-CONTEXT:CLEAR-SUCCESS":
            return { ...defaultState, isLoading: false };

        case "MARKETPLACE-CONTEXT:CLEAR-ERROR":
            return { ...state, isLoading: false, error: payload };

        default:
            return state;
    }
};

export default marketplaceContextReducer;